import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=12b37cfa&scoped=true&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=12b37cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b37cfa",
  null
  
)

export default component.exports